import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Container, Row, Col, Form, Table, Modal, Card, Button, ButtonGroup } from 'react-bootstrap';
import { BiSearchAlt, BiListOl } from 'react-icons/bi';
import Select from 'react-select';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../shared/Shared.css';
import * as moment from 'moment';
import $ from 'jquery';
import { Alert } from "../../shared/Alerts";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { SharedService } from '../../services/SharedService';
import { VedikaService } from '../../services/VedikaService';
import { DateService } from '../../shared/DateService';

const DaftarRegistrasiPasien = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [listDokter, setlistDokter] = useState([]);
    const [listInstalasi, setlistInstalasi] = useState([]);
    const [listRuangan, setlistRuangan] = useState([]);
    const [listKelompok, setlistKelompok] = useState([]);

    const [showDeskripsi, setshowDeskripsi] = useState();

    const [selectedDokter, setSelectedDokter] = useState();
    const [selectedInstalasi, setSelectedInstalasi] = useState();
    const [selectedRuangan, setSelectedRuangan] = useState();
    const [selectedKelompok, setSelectedKelompok] = useState();
    const [periodeAwal, setperiodeAwal] = useState();
    const [periodeAkhir, setperiodeAkhir] = useState();

    const loadInit = () => {
        const promise1 = SharedService.comboOperator();
        const allPromise = Promise.all([promise1]);
        allPromise.then(val => {
            setlistDokter(val[0].data.dokter);
            setlistInstalasi(val[0].data.departemen);
            setlistKelompok(val[0].data.kelompokpasien);
        })
    }

    const handleChangeDokter = (row) => {
        setSelectedDokter(row);
    }

    const handleChangeInstalasi = (row) => {
        setSelectedInstalasi(row);
        setlistRuangan(row.ruangan);
    }
    const handleChangeRuangan = (row) => {
        setSelectedRuangan(row)
    }
    const handleChangeKelompok = (row) => {
        setSelectedKelompok(row);
    }
    const handlePeriodeAwal = () => {
        setperiodeAwal($('#periodeawal').val());
    }
    const handlePeriodeAkhir = () => {
        setperiodeAkhir($('#periodeakhir').val());
    }
    const search = () => {
        let tglAwal = moment(periodeAwal).format('YYYY-MM-DD HH:mm:ss');
        let tglAkhir = moment(periodeAkhir).format('YYYY-MM-DD HH:mm:ss');
        let param = '';
        param += periodeAwal ? `tglAwal=${tglAwal}` : '';
        param += periodeAkhir ? `&tglAkhir=${tglAkhir}` : '';
        param += selectedDokter ? `&dokId=${selectedDokter.id}` : '';
        param += selectedInstalasi ? `&deptId=${selectedInstalasi.id}` : '';
        param += selectedRuangan ? `&ruangId=${selectedRuangan.id}` : '';
        param += selectedKelompok ? `&kelId=${selectedKelompok.id}` : '';
        param += $('#rows').val() ? `&jmlRows=${$('#rows').val()}` : '';
        param += $('#noreg').val() ? `&noreg=${$('#noreg').val()}` : '';
        param += $('#norm').val() ? `&norm=${$('#norm').val()}` : '';
        param += $('#nama').val() ? `&nama=${$('#nama').val()}` : '';
        setIsLoading(true)
        VedikaService.daftarPasien(param)
            .then((res) => {
                $('#dtList').DataTable().clear().draw();
                if (res.data.length > 0) {
                    res.data.forEach((val, index) => {
                        let umur = DateService.CountAge(new Date(val.tgllahir), new Date(val.tglregistrasi));
                        let bln = umur.month,
                            thn = umur.year,
                            day = umur.day

                        res.data[index].umur = day + 'hr ' + bln + 'bln ' + thn + 'thn'
                    });
                }
                return res;
            })
            .then((res) => {
                if (res.data.length > 0) {
                    loadDtList(res.data);
                } else {
                    swal({
                        title: 'Tidak ada data',
                        text: '',
                        icon: "warning",
                        button: "OK",
                    })
                        .then((val) => {
                        });
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleCloseDeskripsi = () => setshowDeskripsi(false);
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        let param = `norecfk=${row.norec}`;
        VedikaService.dokumenVedika(param)
            .then((res) => {
                $('#dtListFile').DataTable().destroy();
                if (res.data.data.length > 0) {
                    loadDtListFile(res.data.data)
                }
            })
    }

    const handleShowFile = (row) => {
        $('#frameFile').attr("src",row.url);
    }

    const loadDtList = (res) => {
        $('#dtList').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            columns: [
                {
                    targets: [0],
                    data: null,
                    // createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    data: 'tglregistrasi',
                },
                {
                    targets: [2],
                    data: 'noregistrasi',
                },
                {
                    targets: [3],
                    data: 'nocm',
                },
                {
                    targets: [4],
                    data: 'namapasien',
                },
                {
                    targets: [5],
                    data: 'namaruangan',
                },
                {
                    targets: [6],
                    data: 'namadokter',
                },
                {
                    targets: [7],
                    data: 'kelompokpasien',
                },
                {
                    targets: [8],
                    data: 'namarekanan',
                },
                {
                    targets: [9],
                    data: 'tglpulang',
                },
                {
                    targets: [10],
                    data: 'nostruk',
                },
                {
                    targets: [11],
                    data: 'nosep',
                },
            ]
        })
    }

    const loadDtListFile = (res) => {
        $('#dtListFile').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            columns: [
                {
                    targets: [0],
                    data: 'tanggal_document',
                    width:30,
                },
                {
                    targets: [1],
                    data: 'nam_file',
                },
                {
                    targets: [2],
                    data: null,
                    width:30,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Files' onClick={() => handleShowFile(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
            ]
        })
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        loadInit()
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Container fluid className='pb-5'>
                <Row>
                    <Col className='text-center bg-success text-white'>
                        <h5>Daftar Registrasi Pasien</h5>
                    </Col>
                </Row>
                <Row className='mb-1 pt-1'>
                    <Form.Group as={Col} controlId="dokter">
                        <Form.Label>Dokter</Form.Label>
                        <Select
                            cacheOptions
                            styles={customStyles}
                            value={selectedDokter}
                            getOptionLabel={e => e.namalengkap}
                            getOptionValue={e => e.id}
                            options={listDokter}
                            onChange={handleChangeDokter}
                        />
                    </Form.Group>
                    <Form.Group as={Col} controlId="instalasi">
                        <Form.Label>Instalasi</Form.Label>
                        <Select
                            cacheOptions
                            styles={customStyles}
                            value={selectedInstalasi}
                            getOptionLabel={e => e.departemen}
                            getOptionValue={e => e.id}
                            options={listInstalasi}
                            onChange={handleChangeInstalasi}
                        />
                    </Form.Group>
                    <Form.Group as={Col} controlId="ruangan">
                        <Form.Label>Ruangan</Form.Label>
                        <Select
                            cacheOptions
                            styles={customStyles}
                            value={selectedRuangan}
                            getOptionLabel={e => e.ruangan}
                            getOptionValue={e => e.id}
                            options={listRuangan}
                            onChange={handleChangeRuangan}
                        />
                    </Form.Group>
                    <Form.Group as={Col} controlId="kelompok">
                        <Form.Label>Kelompok</Form.Label>
                        <Select
                            cacheOptions
                            styles={customStyles}
                            value={selectedKelompok}
                            getOptionLabel={e => e.kelompokpasien}
                            getOptionValue={e => e.id}
                            options={listKelompok}
                            onChange={handleChangeKelompok}
                        />
                    </Form.Group>
                    <Form.Group as={Col} controlId="periodeawal">
                        <Form.Label>Periode Awal</Form.Label>
                        <Form.Control size="sm" type="datetime-local" onChange={handlePeriodeAwal} ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="periodeakhir">
                        <Form.Label>Periode Akhir</Form.Label>
                        <Form.Control size="sm" type="datetime-local" onChange={handlePeriodeAkhir}></Form.Control>
                    </Form.Group>
                </Row>
                <Row className='mb-3 pt-1'>
                    <Col md={8}>
                        <Row>
                            <Form.Group as={Col} controlId="noreg">
                                <Form.Label>No Registrasi</Form.Label>
                                <Form.Control type="text" size="sm"></Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} controlId="norm">
                                <Form.Label>No RM(Rekam Medis)</Form.Label>
                                <Form.Control type="text" size="sm"></Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} controlId="nama">
                                <Form.Label>Nama</Form.Label>
                                <Form.Control type="text" size="sm"></Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} controlId="rows">
                                <Form.Label>Rows</Form.Label>
                                <Form.Control type="number" defaultValue={50} size="sm"></Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} id="search">
                                <div className="d-grid gap-2">
                                    <Button className='mtc-2' variant="success" size="sm" onClick={search}><BiSearchAlt />Cari</Button>
                                </div>
                            </Form.Group>
                        </Row>
                    </Col>
                    <Col md={4}>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Table responsive="sm" size="sm" id='dtList' bordered hover style={{ fontSize: 'smaller' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Tgl Registrasi</th>
                                    <th>No Reg</th>
                                    <th>No RM</th>
                                    <th>Nama Pasien</th>
                                    <th>Nama Ruangan</th>
                                    <th>DPJP</th>
                                    <th>Kelompok Pasien</th>
                                    <th>Penjamin</th>
                                    <th>Tgl Pulang</th>
                                    <th>No Verif</th>
                                    <th>No SEP</th>
                                </tr>
                            </thead>
                        </Table>
                    </Col>
                </Row>
            </Container>
            {/* <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                fullscreen={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={4}>
                            <Card>
                                <Card.Header>File</Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Table responsive="sm" size="sm" id='dtListFile' bordered hover style={{ fontSize: 'smaller' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Tanggal Upload</th>
                                                        <th>Nama File</th>
                                                        <th>File</th>
                                                    </tr>
                                                </thead>
                                            </Table>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={8}>
                            <iframe id='frameFile' width="850" height="600"></iframe>
                        </Col>
                    </Row>
                    
                </Modal.Body>
            </Modal> */}
        </React.Fragment>
    )
}
export default DaftarRegistrasiPasien;